module.exports = __webpack_public_path__ + "158c92036e1bddf8f4187050eb34c01a.svg";